module.exports = __webpack_public_path__ + "img/business-plan.f81315f3.svg";